// extracted by mini-css-extract-plugin
module.exports = {"header":"Headline-module__header--27xC3","headerActions":"Headline-module__headerActions--LCN_0"};